import * as tslib_1 from "tslib";
import { getRefreshToken } from '../services/getRefreshToken';
import { newSyncRequest } from '../services/newSyncRequest';
import { setSyncRequest } from '../services/setSyncRequest';
import { connectedAccountsStore } from '../store/store';
import { initConnectedAccountsFull } from '../orchestrators/initConnectedAccountsFull';
import { updateGmailIsConnecting } from '../actions/connectGmail/updateGmailIsConnecting';
import { toggleConnectGmailWindow } from '../actions/connectGmail/toggleConnectGmailWindow';
import { updateEditIsSaving } from '../actions/editAccount/updateEditIsSaving';
import { toggleEditAccountWindow } from '../actions/editAccount/toggleEditAccountWindow';
import { getEditAccountSyncRequest } from '../selectors/getEditAccountSyncRequest';
export function connectGmailWithAuthCode(authorizationCode) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var store, tokenResponse, response, request, response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    store = connectedAccountsStore();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 7, 8]);
                    if (store.dialogWindowState.connectGmailOpen) {
                        updateGmailIsConnecting(true);
                    }
                    else if (store.dialogWindowState.editAccountOpen) {
                        updateEditIsSaving(true);
                    }
                    return [4 /*yield*/, getRefreshToken(authorizationCode)];
                case 2:
                    tokenResponse = _a.sent();
                    if (!!tokenResponse.ErrorMessage) return [3 /*break*/, 6];
                    if (!store.dialogWindowState.connectGmailOpen) return [3 /*break*/, 4];
                    return [4 /*yield*/, newSyncRequest({
                            EmailAddress: tokenResponse.OAuth2RefreshTokenInfo.EmailAddress,
                            Name: tokenResponse.OAuth2RefreshTokenInfo.EmailAddress,
                            DisplayName: store.connectGmailState.displayName ||
                                tokenResponse.OAuth2RefreshTokenInfo.EmailAddress,
                            IncomingAuth: 'OAuth',
                            OAuthProvider: 4 /* Google */,
                            RefreshToken: tokenResponse.OAuth2RefreshTokenInfo.RefreshToken,
                            SyncProtocol: 'Imap',
                            IncomingServer: 'imap.gmail.com',
                            IncomingPort: 993,
                            SmtpServerName: 'smtp.gmail.com',
                            SmtpServerPort: 587,
                            IncomingSecurity: 'Ssl',
                            RemoteSendEnabled: true,
                            TargetRootFolder: store.connectGmailState.targetRootFolderEnabled
                                ? 'true'
                                : null,
                        })];
                case 3:
                    response = _a.sent();
                    if (!response.ErrorMessage) {
                        initConnectedAccountsFull();
                    }
                    return [3 /*break*/, 6];
                case 4:
                    if (!store.dialogWindowState.editAccountOpen) return [3 /*break*/, 6];
                    request = getEditAccountSyncRequest();
                    request.RefreshToken = tokenResponse.OAuth2RefreshTokenInfo.RefreshToken;
                    return [4 /*yield*/, setSyncRequest(request)];
                case 5:
                    response = _a.sent();
                    if (!response.ErrorMessage) {
                        initConnectedAccountsFull();
                    }
                    _a.label = 6;
                case 6: return [3 /*break*/, 8];
                case 7:
                    if (store.dialogWindowState.connectGmailOpen) {
                        updateGmailIsConnecting(false);
                        toggleConnectGmailWindow({ connectGmailOpen: false });
                    }
                    else if (store.dialogWindowState.editAccountOpen) {
                        updateEditIsSaving(false);
                        toggleEditAccountWindow({ editAccountOpen: false });
                    }
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=connectGmailWithAuthCode.js.map